import { lazy } from "react";
import { Route } from "../../RouteModel";

const CashManagementProviderCustomerConfigCreate = lazy(
  () =>
    import(
      "../../../pages/configuration/customers/cash-management/provider-config/Create"
    )
);
const CashManagementProviderCustomerConfigList = lazy(
  () =>
    import(
      "../../../pages/configuration/customers/cash-management/provider-config/List"
    )
);
const CashManagementProviderCustomerConfigDetails = lazy(
  () =>
    import(
      "../../../pages/configuration/customers/cash-management/provider-config/Details"
    )
);
const CashManagementProviderCustomerConfigEdit = lazy(
  () =>
    import(
      "../../../pages/configuration/customers/cash-management/provider-config/Edit"
    )
);

export const cashManagementProviderConfigRoutes: Route[] = [
  {
    i18nName: "Provider Configuration",
    path: "/configuration/customers/:id/cash-management/provider-config",
    component: CashManagementProviderCustomerConfigList,
    showChildrenInSidebar: false,
    can: {
      do: "details",
      on: "cash-management-provider-setup",
    },
    children: [
      {
        i18nName: "Create provider configuration",
        path:
          "/configuration/customers/:customerId/cash-management/provider-config/create/:providerId",
        component: CashManagementProviderCustomerConfigCreate,
        can: {
          do: "create",
          on: "account",
        },
      },
      {
        i18nName: "Provider configuration details",
        path:
          "/configuration/customers/:customerId/cash-management/provider-config/:configId",
        component: CashManagementProviderCustomerConfigDetails,
        can: {
          do: "details",
          on: "account",
        },
      },
      {
        i18nName: "Edit provider configuration",
        path:
          "/configuration/customers/:customerId/cash-management/provider-config/:configId/edit",
        component: CashManagementProviderCustomerConfigEdit,
        can: {
          do: "update",
          on: "account",
        },
      },
    ],
  },
];
